import React from 'react'
import Navbar_back_btn from '../../UiComponents/Navbar_back_btn';
import "./Contactus.css";

export default function Contactus() {
  return (
    <div className='contact_main_block'>
        <div>
            <Navbar_back_btn />
        </div>
      <div className='contact_block2 '>
        <div className='contact_div1'>
        <div className='contact_div1_sub1'></div>
        <div className='contact_div2_sub2'>
          <div className='contact_sub2_div1'>
          <h1 className='contact_sub2_div1_text1'>Contact Us</h1>
          </div>
          <div className='contact_sub2_div2'>
            <input className='contact_input1' type="text" placeholder="Enter name" />
          </div>
          <div className='contact_sub2_div2'>
            <input className='contact_input1' type="text" placeholder="Enter e-mail" />
          </div>
          <div className='contact_sub2_div2'>
            <input className='contact_input1' type="text" placeholder="Subject" />
          </div>
          <div className='contact_sub2_div2'>
            <textarea className='contact_textarea1' type="text" placeholder="Detail description" />
          </div>
          <div className='contact_sub2_div3'>
            <div>
              <h1 className='contact_sub2_div3_text1'>Take a look at the FAQs</h1>
            </div>
            <div>
              <button className='contact_submit_btn'>Submit</button>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  )
}
